import {create} from "zustand";

type NavigationLoaderStore = {
    loading: boolean;
    setLoading: (loading: boolean) => void;
};

export const useNavigationLoaderStore = create<NavigationLoaderStore>((set) => ({
    loading: false,
    setLoading: (loading) => set({loading}),
}));
